import React from "react";

/**
 * Big-number KPI tile. Primary figure, trend arrow vs prior period,
 * optional short context line beneath.
 *
 * Props:
 *   label: short human label ("People who found you")
 *   value: primary value (already formatted — number, string, or element)
 *   deltaPct: number or null — used to render the trend pill
 *   footnote: optional string displayed beneath the value
 *   invert: set true when "up" is bad (e.g. bounce rate); swaps arrow colour
 */
export default function MetricTile({ label, value, deltaPct, footnote, invert }) {
  return (
    <div className="metric-tile">
      <div className="metric-label">{label}</div>
      <div className="metric-value">{value ?? "—"}</div>
      <TrendPill deltaPct={deltaPct} invert={invert} />
      {footnote && <div className="metric-footnote">{footnote}</div>}
    </div>
  );
}

function TrendPill({ deltaPct, invert }) {
  if (deltaPct == null || Number.isNaN(deltaPct)) {
    return <div className="metric-trend flat">— vs last month</div>;
  }
  const rounded = Math.round(deltaPct * 10) / 10;
  const up = rounded > 0;
  const flat = rounded === 0;
  let direction = "flat";
  if (!flat) {
    const goodUp = !invert;
    direction = (up === goodUp) ? "up" : "down";
  }
  const arrow = flat ? "→" : up ? "↑" : "↓";
  return (
    <div className={`metric-trend ${direction}`}>
      {arrow} {Math.abs(rounded).toFixed(1)}% vs last month
    </div>
  );
}

export function formatNumber(n) {
  if (n == null) return "—";
  if (typeof n !== "number") return n;
  if (Math.abs(n) >= 1000) return n.toLocaleString(undefined, { maximumFractionDigits: 0 });
  return n.toString();
}
